import React from 'react';
import {
  AuthProvider,
  ProductsProvider,
  FiltersProvider,
  ValuesProvider,
  DialogProvider
} from 'contexts';

import ListOfValues from "./ListOfValues";

export default () => {
  return (
    <AuthProvider>
      <ProductsProvider>
        <FiltersProvider>
          <ValuesProvider>
            <DialogProvider>
              <ListOfValues/>
            </DialogProvider>
          </ValuesProvider>
        </FiltersProvider>
      </ProductsProvider>
    </AuthProvider>
  );
}